import axiosInstance from '../helpers/axios';

/** /api/ops/sync — the freshness loop: data-as-of, run history, conflicts. */

export type TSyncRun = {
  id: string;
  mode: string | null;
  startedAt: string | null;
  finishedAt: string | null;
  ok: boolean;
  /** partial = finished, but the objects in failedObjects did not refresh */
  status: 'ok' | 'partial' | 'failed' | 'running';
  running: boolean;
  failedObjects: { object: string; error: string | null }[];
  error: string | null;
  summary: string | null;
};

export type TSyncStatus = {
  dataAsOf: string | null;
  ageHours: number | null;
  stale: boolean;
  lastRun: Omit<TSyncRun, 'id'> | null;
  openConflicts: number;
  runs: TSyncRun[];
  objects: {
    object: string;
    cursor: string | null;
    lastRunAt: string | null;
  }[];
  recentLog: {
    at: string | null;
    object: string | null;
    upserted: number | null;
    merged: number | null;
    tombstoned: number | null;
    conflicts: number;
    error: string | null;
  }[];
};

export type TSyncConflict = {
  id: string;
  object: string | null;
  targetId: string | null;
  label: string | null;
  at: string | null;
  portalEditor: string | null;
  portalEditedAt: string | null;
  salesforceStamp: string | null;
  fields: { field: string; portal: unknown; salesforce: unknown }[];
  status: 'open' | 'resolved';
  resolvedBy: string | null;
  resolvedAt: string | null;
  resolution: 'portal' | 'salesforce' | null;
};

export const getSyncStatus = async () =>
  (await axiosInstance.get<TSyncStatus>('ops/sync/status')).data;

export const getSyncConflicts = async (status: 'open' | 'resolved' | 'all') =>
  (
    await axiosInstance.get<{ items: TSyncConflict[] }>('ops/sync/collisions', {
      params: { status },
    })
  ).data.items;

export const resolveSyncConflict = async (
  id: string,
  choice: 'portal' | 'salesforce',
) =>
  (
    await axiosInstance.post<{ id: string; status: string }>(
      `ops/sync/collisions/${id}/resolve`,
      { choice },
    )
  ).data;
